/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export type {
  LoggerProviderConfig,
  LoggerProviderOptions,
  LoggerConfig,
  LoggerConfigurator,
  LogRecordLimits,
  BatchLogRecordProcessorOptions,
  BatchLogRecordProcessorBrowserOptions,
} from './types';
export { LoggerProvider } from './LoggerProvider';
export type { SdkLogRecord } from './export/SdkLogRecord';
export type { LogRecordProcessor } from './LogRecordProcessor';
export type { ReadableLogRecord } from './export/ReadableLogRecord';
export { ConsoleLogRecordExporter } from './export/ConsoleLogRecordExporter';
export type { LogRecordExporter } from './export/LogRecordExporter';
export { SimpleLogRecordProcessor } from './export/SimpleLogRecordProcessor';
export { InMemoryLogRecordExporter } from './export/InMemoryLogRecordExporter';
export { BatchLogRecordProcessor } from './platform';
export {
  createLoggerConfigurator,
  type LoggerPattern,
} from './config/LoggerConfigurators';
